module.exports = __webpack_public_path__ + "img/24_2.9c0e39df.png";